module.exports = __webpack_public_path__ + "img/gk_img3.40e20afc.png";